// no idea what this does 😅

export const deNullRef = <T = any>(ref: any) => (ref.current === null ? null : (ref as React.RefObject<T>));
